import { generateMockMatterInsurancePayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterInsurance } from "@/lib/data/react-query/matters/matter-insurance";
import type { Contact } from "@/lib/types";
import { createInsuranceContactConnectionChildInput } from "@/lib/utils/connections/insurance-contact-connections";
import { useCallback } from "react";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterInsurance = () => {
  const createInsurance = useCreateMatterInsurance();

  const createMockMatterInsurance = useCallback(
    async (
      matterId: string,
      insuredContact: Contact,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createInsurance.mutateAsync({
          ...generateMockMatterInsurancePayload(matterId, overrides),
          connections: [
            createInsuranceContactConnectionChildInput(
              insuredContact.id,
              "Insured",
            ),
          ],
        }),
      ),
    [createInsurance],
  );

  return {
    createMockMatterInsurance,
    mutation: createInsurance,
  };
};
